import { render, staticRenderFns } from "./PermissionPage.vue?vue&type=template&id=2d690841&"
import script from "./PermissionPage.vue?vue&type=script&lang=js&"
export * from "./PermissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d690841')) {
      api.createRecord('2d690841', component.options)
    } else {
      api.reload('2d690841', component.options)
    }
    module.hot.accept("./PermissionPage.vue?vue&type=template&id=2d690841&", function () {
      api.rerender('2d690841', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/PermissionPage.vue"
export default component.exports